export const residencias = [
    {
        'residencia' : 'Actopan',
        'direccion' : 'Carr. Actopan - El Rincón esq. Calle Pedregal s/n, col. La Peña, Actopan, Hidalgo.',
        'telefono' : 'Of. 772 727 20 81. Cel. 771 702 02 85',
        'correo' : 'residenciaactopan7@gmail.com',
    },
    {
        'residencia' : 'Apan',
        'direccion' : 'Calle Brasil Mza. 1 Lte. 22, Colonia Palmillas, Cd. Sahagún, Tepeapulco, Hidalgo.',
        'telefono' : 'Of. 791 913 55 33. Cel. 771 418 64 96',
        'correo' : 'carfer160767@gmail.com',
    },
    {
        'residencia' : 'Huejutla',
        'direccion' : 'Av. Pablo Anaya s/n, col. Aviación Civil, Huejutla de Reyes, Hidalgo.',
        'telefono' : 'Cel. 771 216 78 25',
        'correo' : 'conservacion_huejutla10@hotmail.com',
    },
    {
        'residencia' : 'Huichapan',
        'direccion' : 'Av. Gobernador Javier Rojo Gómez No. 3, col. Centro Histórico, Huichapan, Hidalgo.',
        'telefono' : 'Of. 761 782 02 03. Cel. 771 111 37 85.',
        'correo' : 'gus_6414@yahoo.com.mx',
    },
    {
        'residencia' : 'Ixmiquilpan',
        'direccion' : 'Calle Melchor Ocampo No. 153, col. El Oro, Ixmiquilpan, Hidalgo.',
        'telefono' : 'Of. 759 723 25 55. Cel. 771 202 53 33',
        'correo' : 'sopdgc@hotmail.com',
    },
    {
        'residencia' : 'Jacala',
        'direccion' : 'Se atiende a través de la Residencia de Ixmiquilpan',
        'telefono' : 'Cel. 771 202 53 33',
        'correo' : 'sopdgc@hotmail.com',
    },
    {
        'residencia' : 'Metztitlán',
        'direccion' : 'Calle 5 de Mayo s/n Barrio Coatlán, Metztitlán Hidalgo.',
        'telefono' : 'Of. 774 743 19 16, Cel. 771 189 76 93',
        'correo' : 'solis200954@hotmail.com',
    },
    {
        'residencia' : 'Molango',
        'direccion' : 'Calle Ramírez s/n, Barrio Alameda, Molango de Escamilla, Hidalgo.',
        'telefono' : 'Of. 774 745 01 13. Cel. 771 189 76 93',
        'correo' : 'solis200954@hotmail.com',
    },
    {
        'residencia' : 'Pachuca',
        'direccion' : 'Blvd. El Minero No. 1120, col. Villa Aquiles Serdán, Pachuca de Soto, Hidalgo.',
        'telefono' : 'Cel. 771 124 88 13',
        'correo' : 'residenciapachuca2018@outlook.com',
    },
    {
        'residencia' : 'Progreso',
        'direccion' : 'Calle Gómez Farías esq. Libertad, col. Centro, Progreso de Obregón, Hidalgo.',
        'telefono' : 'Of. 738 725 00 04. Cel. 771 209 18 86',
        'correo' : 'residenciaprogreso@hotmail.com',
    },
    {
        'residencia' : 'Tulancingo',
        'direccion' : 'Carr. Tulancingo - Santiago Tulantepec km. 2.8, Santiago Tulantepec de Lugo Guerrero, Hidalgo.',
        'telefono' : 'Of. 775 753 52 10. Cel. 771 109 56 81',
        'correo' : 'conservacon_tulancingo@outlook.com',
    },
    {
        'residencia' : 'Señalamiento',
        'direccion' : 'Calle Cerrada de Oyamel, s/n, col. El Tezontle, Pachuca de Soto, Hidalgo.',
        'telefono' : 'Of. 771 710 85 78. Cel. 771 135 18 00',
        'correo' : 'alexschez01@hotmail.com',
    },
]